import * as React from 'react';
import { classes, style } from 'typestyle';
import { regularStyle } from '../..';
import { Black, Blue, GrayCream, GrayDark, White } from '../../styles/colors';
import { borderPx, inputDefaultBorderColor } from '../../styles/input';
class Input extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        const text = e.target.value;
        this.props.onChange(text);
    }
    render() {
        const { autoFocus, name, value, placeholder, className, disabled = false, readonly = false, type = 'text', tabIndex, } = this.props;
        return (React.createElement("input", { autoFocus: autoFocus, name: name, type: type, className: classes('ta-atom-input', className, regularStyle, inputStyle, disabled && disabledStyle), readOnly: readonly, disabled: disabled, placeholder: placeholder, onFocus: () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            }, onBlur: () => {
                if (this.props.onBlur) {
                    this.props.onBlur();
                }
            }, onChange: this.handleChange, value: value, tabIndex: tabIndex }));
    }
}
export default Input;
export const disabledStyle = style({
    color: `${GrayDark} !important`,
    background: `${GrayCream} !important`,
    $nest: {
        '&::placeholder': {
            color: `${GrayDark} !important`,
        },
    },
});
export const inputStyle = style({
    width: '100%',
    height: 40,
    boxSizing: 'border-box',
    padding: '10px 12px',
    color: Black,
    background: White,
    boxShadow: `inset 0px 0px 0px ${borderPx}px ${inputDefaultBorderColor}`,
    borderRadius: 12,
    outline: 'none',
    border: 0,
    $nest: {
        '&::placeholder': {
            color: Blue,
        },
    },
});
//# sourceMappingURL=Input.js.map